import { RISK_PROFILES_LIST_STATE_KEYS } from 'RiskProfilesApp/apps/risk-profiles-list-app/state/constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { getListPageRedirectUrl } from 'AccountsApp/ts/utils/utils';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "Angular/services/core/ajax.service";
import * as i3 from "Angular/services/core/urls.service";
export class RiskProfilesService {
    constructor(accountsService, ajaxService, urlsService) {
        this.accountsService = accountsService;
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getRiskProfiles(dataSource = 'legacy') {
        const url = this.urlsService.getUrl(this.urlsService.RISK_PROFILES.COLLECTION, {}, { data_source: dataSource });
        return this.ajaxService.getDataObserveBody(url);
    }
    getRiskProfile(riskProfileId) {
        const urlParams = { riskProfileId };
        const url = this.urlsService.getUrl(this.urlsService.RISK_PROFILES.RISK_PROFILE, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getRiskProfilesList(params) {
        const url = this.urlsService.RISK_PROFILES.LIST_COLLECTION;
        return this.ajaxService.getDataObserveBody(url, params);
    }
    getFolderableItems(params) {
        return this.ajaxService.getDataObserveBody(this.urlsService.RISK_PROFILES.LIST_MODAL_COLLECTION, params);
    }
    async getRiskProfileListPageRedirectUrl(overrides) {
        return getListPageRedirectUrl(this.accountsService, this.urlsService.RISK_PROFILES.LIST, 'risk_profiles_list_page', RISK_PROFILES_LIST_STATE_KEYS, overrides);
    }
    postRiskProfilesCollection(params) {
        const url = this.urlsService.RISK_PROFILES.COLLECTION;
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    putRiskProfile(riskProfileId, params) {
        const url = this.urlsService.getUrl(this.urlsService.RISK_PROFILES.RISK_PROFILE, {
            riskProfileId,
        });
        return this.ajaxService.putJsonDataObserveBody(url, params);
    }
    duplicateRiskProfile(riskProfileId, newName, targetFolder) {
        const url = this.urlsService.getUrl(this.urlsService.RISK_PROFILES.DUPLICATE, { riskProfileId });
        const postParams = { name: newName, targetFolder };
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    deleteRiskProfile(riskProfileId) {
        const url = this.urlsService.getUrl(this.urlsService.RISK_PROFILES.RISK_PROFILE, {
            riskProfileId,
        });
        return this.ajaxService.deleteDataObserveBody(url);
    }
    /**
     * Fetches categorized holdings for broad asset class.
     *
     * @param securityId: Security ID (benchmark ID in this case).
     */
    getBroadAssetClassBreakdown(securityId) {
        const url = this.urlsService.getUrl(this.urlsService.RISK_PROFILES.BROAD_ASSET_CLASS, { securityId });
        return this.ajaxService.getDataObserveBody(url);
    }
    /**
     * Fetches financial metrics breakdown.
     *
     * @param securityId: Security ID (benchmark ID in this case).
     * @param metrics: List of financial metric names to fetch.
     */
    getFinancialMetricsBreakdown(securityId, metrics) {
        const url = this.urlsService.getUrl(this.urlsService.RISK_PROFILES.FINANCIAL_METRICS, { securityId });
        const params = { metrics };
        return this.ajaxService.getDataObserveBody(url, params);
    }
}
RiskProfilesService.ɵfac = function RiskProfilesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskProfilesService)(i0.ɵɵinject(i1.AccountsService), i0.ɵɵinject(i2.AjaxService), i0.ɵɵinject(i3.UrlsService)); };
RiskProfilesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RiskProfilesService, factory: RiskProfilesService.ɵfac, providedIn: 'root' });
